const API_URL = "https://api.satvalogic.com";
const authToken = localStorage.getItem("authToken");
const AUTH_HEADER = {
  Authorization: `Bearer ${authToken}`,
  "Content-Type": "application/json",
};
function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem("authToken");

  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  return fetch(url, { ...options, headers }).then(async (res) => {
    if (res.status === 401) {
      // Redirect to login
      localStorage.removeItem("authToken");
      window.location.href = "/login";
      return; // Stop further execution
    }

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(errorText || "API request failed");
    }
    return res;
  });
}

const apis = {
  async login(username, password) {
    const res = await fetchWithAuth(`${API_URL}/auth/login`, {
      method: "POST",
      headers: AUTH_HEADER,
      body: JSON.stringify({ username, password }),
    });
    if (!res.ok) throw new Error("Failed to login");
    return res.json();
  },
  async getOrdersPerMonth() {
    const res = await fetchWithAuth(`${API_URL}/dashboard/orders-per-month`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch orders per month");
    return res.json();
  },
  async getPendingOrder() {
    const res = await fetchWithAuth(`${API_URL}/dashboard/pending-orders`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch orders");
    return res.json();
  },
  async getDashboardTotals() {
    const res = await fetchWithAuth(`${API_URL}/dashboard/totals`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch totals");
    return res.json();
  },
  async getCustomers() {
    const res = await fetchWithAuth(`${API_URL}/customers`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch totals");
    return res.json();
  },
  async getCustomerById(id) {
    const res = await fetchWithAuth(`${API_URL}/customers/${id}`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch totals");
    return res.json();
  },
  async updateCustomerById(id, payload) {
    const res = await fetchWithAuth(`${API_URL}/customers/${id}`, {
      method: "PUT",
      headers: AUTH_HEADER,
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to fetch customers");
    return res.json();
  },
  async createCustomer(newCustomerFields) {
    const res = await fetchWithAuth(`${API_URL}/customers`, {
      headers: AUTH_HEADER,
      method: "POST",
      body: JSON.stringify(newCustomerFields),
    });
    if (!res.ok) throw new Error("Failed to Create Customer");
    return res.json();
  },
  async quotationCreateUpdate(data, method, url) {
    const res = await fetchWithAuth(`${API_URL}/${url}`, {
      headers: AUTH_HEADER,
      method: method,
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error("Failed to Create quotation");
    return res.json();
  },
  async getQuotationById(id) {
    const res = await fetchWithAuth(`${API_URL}/quotations/${id}`, {
      headers: AUTH_HEADER,
      method: "GET",
    });
    if (!res.ok) throw new Error("Failed to get quotation");
    return res.json();
  },
  async convertPi(id, date) {
    const res = await fetchWithAuth(`${API_URL}/quotations/convert-pi/${id}`, {
      headers: AUTH_HEADER,
      method: "PUT",
      body: JSON.stringify({ expectedDeliveryDate: date }),
    });
    if (!res.ok) throw new Error("Failed to update quotation to PI");
    return res.json();
  },
  async getAllQuotation() {
    const res = await fetchWithAuth(`${API_URL}/quotations`, {
      headers: AUTH_HEADER,
      method: "GET",
    });
    if (!res.ok) throw new Error("Failed to get quotation");
    return res.json();
  },
  async getProducts() {
    const res = await fetchWithAuth(`${API_URL}/products`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch products");
    return res.json();
  },
  async getProductById(id) {
    const res = await fetchWithAuth(`${API_URL}/products/${id}`, {
      method: "GET",
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch products");
    return res.json();
  },
  async createProduct(payload) {
    const res = await fetchWithAuth(`${API_URL}/products`, {
      method: "POST",
      headers: AUTH_HEADER,
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to fetch products");
    return res.json();
  },
  async updateProductById(id, payload) {
    const res = await fetchWithAuth(`${API_URL}/products/${id}`, {
      method: "PUT",
      headers: AUTH_HEADER,
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to fetch products");
    return res.json();
  },
  async getCombos() {
    const res = await fetchWithAuth(`${API_URL}/combos`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch combo");
    return res.json();
  },
  async getCombosById(id) {
    const res = await fetchWithAuth(`${API_URL}/combos/${id}`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch combo");
    return res.json();
  },
  async comboUpdateOrCreate(payload, method, url) {
    const res = await fetchWithAuth(`${API_URL}/${url}`, {
      method: method,
      headers: AUTH_HEADER,
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to fetch combo");
    return res.json();
  },
  async getUsers() {
    const res = await fetchWithAuth(`${API_URL}/users`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch Users");
    return res.json();
  },
  async getUserById(id) {
    const res = await fetchWithAuth(`${API_URL}/users/${id}`, {
      method: "GET",
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch Users");
    return res.json();
  },
  async createUser(payload) {
    const res = await fetchWithAuth(`${API_URL}/users`, {
      method: "POST",
      headers: AUTH_HEADER,
      body: JSON.stringify(payload),
    });
    debugger;
    if (!res.ok) throw new Error("Failed to fetch Users");
    return res.json();
  },
  async updateUserById(id, payload) {
    const res = await fetchWithAuth(`${API_URL}/users/${id}`, {
      method: "PUT",
      headers: AUTH_HEADER,
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to fetch users");
    return res.json();
  },
  async getOrders() {
    const res = await fetchWithAuth(`${API_URL}/orders`, {
      headers: AUTH_HEADER,
    });
    if (!res.ok) throw new Error("Failed to fetch order");
    return res.json();
  },
  async completeOrder(id, date) {
    const res = await fetchWithAuth(`${API_URL}/orders/complete/${id}`, {
      headers: AUTH_HEADER,
      method: "PUT",
      body: JSON.stringify({ deliveryDate: date }),
    });
    if (!res.ok) throw new Error("Failed to update Order complete");
    return res.json();
  },
  async sendAndDownloadInvoice(id) {
    const res = await fetchWithAuth(`${API_URL}/orders/send-invoice/${id}`, {
      headers: AUTH_HEADER,
      method: "GET",
    });
    if (!res.ok) throw new Error("Failed to update Order complete");
    return res.blob();
  },
};
export default apis;
